import React from 'react';
import Caption from '../../../Caption';
import Label from '../../../Label';

const RadioLabel = ({
  id,
  dataId,
  label,
  labelTitle,
  caption,
  disabled,
}) => (
  <div>
    <Label
      htmlFor={id}
      title={labelTitle}
      disabled={disabled}
      cursorDisabled={disabled}
      dataId={`${dataId}.label`}
    >
      {label}
    </Label>
    {caption && (
      <Caption
        subdued
        dataId={`${dataId}.caption`}
      >
        {caption}
      </Caption>
    )}
  </div>
);

RadioLabel.defaultProps = {
  caption: null,
  labelTitle: null,
};

export { RadioLabel };
